export default __webpack_public_path__ + "static/media/IntheMood_LOGO_White.50582788.png";